module.exports = __webpack_public_path__ + "files/471e41d71146da795d83ab138a2abf50.svg";